import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-year",
        label: "",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { y_m: "month" },
        options: {
          default: '',
          lastLabel: true,
          useAll: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "연도", "월", "대행결과서(안전)", "대행결과서(보건)"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    if (search.month) {
      conditions.push({ key: "header.month", operator: "=", value: search.month });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getHead: () => {
    return [
      {
        name: "연도",
        key: "header.year",
      },
      {
        name: "월",
        key: "header.month",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.subInfo.업체명",
      },
      {
        name: "대행기관(안전)",
        key: "body.기술지도기관안전",
      },
      {
        name: "대행기관(보건)",
        key: "body.기술지도기관보건",
      },
      {
        name: "대행결과서(안전)",
        key: "body.기술지도결과서안전",
      },
      {
        name: "대행결과서(보건)",
        key: "body.결과서첨부",
      },
      {
        name: "DKS 조치 대상",
        key: "body.DKS",
        style: { minWidth: "120px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      const content = func.getContent(value);
      // 2026-04-10 입력 폼 변경 이후 대행기관·결과서는 body 최상위에 저장되고, 이전 문서는 subInfo 하위에 남아 있다
      // subInfo 에만 값이 있는 문서: postId 158318, 158323, 158332 (2026-09-30 기준, 데이터 이전 후 subInfo 대체 로직 제거 예정)
      const pick = (key) => {
        const own = content[key];
        if (own && (typeof own !== "object" || own.path)) return own;
        return content.subInfo ? content.subInfo[key] : "";
      };
      const toDocsIcon = (file) => ({ type: "docsIcon", file: file && typeof file === "object" ? { ...file } : {} });
      switch (index) {
        case 0:
          return postContent.header.year; // 연도
        case 1:
          return postContent.header.month; // 월
        case 2:
          return content.stdInfo.field_name; // 사업장명
        case 3:
          return content.subInfo.업체명; // 업체명
        case 4:
          return pick("기술지도기관안전"); // 대행기관(안전)
        case 5:
          return pick("기술지도기관보건"); // 대행기관(보건)
        case 6:
          return toDocsIcon(pick("기술지도결과서안전")); // 대행결과서(안전)
        case 7:
          return toDocsIcon(pick("결과서첨부")); // 대행결과서(보건)
        case 8:
          return content.DKS; // DKS 조치 대상
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
